export default __webpack_public_path__ + "static/media/img49.e77cf924.jpg";